import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 28 26",
  "content": "<symbol viewBox=\"0 0 28 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email\">\n    <rect x=\"1\" y=\"3\" width=\"26\" height=\"20\" rx=\"2\" stroke=\"#040405\" stroke-width=\"1.4\" />\n    <path d=\"M1 5a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v3l-11.324 5.226a4 4 0 0 1-3.352 0L1 8V5z\" stroke=\"#040405\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol